<template>
  <div>
    <product-form 
      :product=product 
      action="post" 
      @update-price="(value) => { product.price = value}"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import ProductForm from "@/components/Products/ProductForm";
export default {
  components: {
    ProductForm
  },
  data() {
    return {
      product: {
        name: "",
        price: '',
        currency: "$",
        description: "",
        location: "",
        type: "",
        email: "",
        phone: "",
        description: "",
        location: ""
      }
    }
  },
  computed: {
  }
};
</script>
